import Footer from '../../components/Footer';

function Detail() {
  return (
    <>
      <div className='w-full h-full'>
        <div id='visual'></div>
        <div className='px-5 max-w-[1200px] mx-auto pb-20 pt-20 lg:pt-32'>
          <img
            className='lg:block'
            src={`${process.env.PUBLIC_URL}/assets/images/detail/img_detail.jpg`}
            alt=''
          />
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Detail;
